export interface SchoolPluginTagInterface {
  name?: string
  type?: string
  weight?: number
  /**
   * 是否是虚拟分类【无法编辑】
   *  - 全部
   *  - 未分类
   */
  isVirtual?: boolean
  /**
   * 下属应用数量
   */
  count?: number
  /**
   * 主键 ID
   */
  id: number
}

export class SchoolPluginTag implements SchoolPluginTagInterface {
  name?: string
  type?: string
  weight?: number
  /**
   * 是否是虚拟分类【无法编辑】
   *  - 全部
   *  - 未分类
   */
  isVirtual?: boolean
  /**
   * 下属应用数量
   */
  count?: number
  /**
   * 主键 ID
   */
  id: number

  constructor(props: SchoolPluginTagInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      type: _type,
      weight: _weight,
      isVirtual: _isVirtual,
      count: _count,
      id: _id,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.type = _type
    this.weight = _weight
    this.isVirtual = _isVirtual
    this.count = _count
    this.id = _id
  }
}
